'use strict';

export * from "./colors.js";
export * from "./dom.js";
export * from "./guards.js";
//# sourceMappingURL=index.js.map